import React, { useEffect } from 'react';
import Navbar from '../components/Navbar'; // Adjust path as needed
import Footer from '../components/Footer'; // Adjust path as needed
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy = () => {

  const L = useLanguage();

  return (
    <>

      <Navbar />
      <div className="container-fluid" style={{ backgroundColor: 'white' }}>
        <div className="row justify-content-center align-items-center" style={{ marginRight: '-12px', marginLeft: '-12px' }}>
          <div className="col-8 text-center">
            <h1 className="pt-4 text-instagram"><strong>{L.privacy.title}</strong></h1>
          </div>
        </div>
        <div className="row justify-content-center text-center mt-5">
          <div id="pricing" style={{ fontSize: '15px', width: '100%' }}>
            <p>
              {L.privacy.intro}
            </p>
            <p>
              {L.privacy.infoCollect}
            </p>
            <p>
              {L.privacy.howWeUse}
            </p>
            <p>
              {L.privacy.sharing}
            </p>
            <p>
              {L.privacy.retention}
            </p>
            <p>
              {L.privacy.security}
            </p>
            <p>
              {L.privacy.children}
            </p>
            <p>
              {L.privacy.changes}
            </p>
            <p>
              {L.privacy.contact}
            </p>
            <p>
              {L.privacy.agreement}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
